import Yup from 'utils/validation/yup-extensions';
import Box from '@mui/material/Box';
import AppWrappedRadios from 'pages/ApplicationRequest/components/containers/AppWrappedRadios';
import AppWrappedTextbox from 'pages/ApplicationRequest/components/containers/AppWrappedTextbox';

/**
 * Provider supplement form fields for collecting billing information.
 * @param {{ formik: import('formik').FormikProps<object> }} props
 */
export const BillingSupplement = ({ formik }) => {
	const billingQuestionValue = formik.values[FORM_FIELD_KEYS.BILLING];

	//Cearing the textbox after the radiobutton is toggled
	if (billingQuestionValue === BILLING_OPTIONS[1] &&
		formik.values[FORM_FIELD_KEYS.BILLING_NEEDS]
	) {
		formik.setFieldValue(
			FORM_FIELD_KEYS.BILLING_NEEDS,
			''
		);
	}

	return (
		<Box
			sx={{
				'& h6': {
					marginBottom: '0',
				},
			}}
		>
			<AppWrappedRadios
				name={FORM_FIELD_KEYS.BILLING}
				label='Does provider have private practice billing needs?'
				helperText='ex. Employed for Trauma surgery, Not Employed for Outpatient Services'
				formik={formik}
				options={BILLING_OPTIONS}
				isRequired
			/>
			{billingQuestionValue === BILLING_OPTIONS[0] && (
				<AppWrappedTextbox
				name={FORM_FIELD_KEYS.BILLING_NEEDS}
				label='Billing Needs'
				formik={formik}
				isRequired
			/>
			)}
		</Box>
	);
};

const BILLING_OPTIONS = ['Yes', 'No'];

export const FORM_FIELD_KEYS = {
	BILLING: 'BILLING',
	BILLING_NEEDS: 'BILLING_NEEDS',
};

export const INITIAL_VALUES = {
	[FORM_FIELD_KEYS.BILLING]: '',
	[FORM_FIELD_KEYS.BILLING_NEEDS]: '',
};

export const VALIDATION_SCHEMA = {
	[FORM_FIELD_KEYS.BILLING]: Yup.string().required(
		'This field is required.',
	),
	[FORM_FIELD_KEYS.BILLING_NEEDS]: Yup.string().when(
		FORM_FIELD_KEYS.BILLING,
		{
			is: 'Yes',
			then: schema => schema.required('Billing needs is required.')
			.max(100, 'Billing needs cannot exceed 100 characters.')
			.matches(
				/^[A-Za-z0-9\s.,'()-]*$/,
				'Special characters are not allowed.',
			),
			otherwise: schema => schema.notRequired(),
		},
	),
};
